import { render, staticRenderFns } from "./AuthForgot.vue?vue&type=template&id=15d42261&"
import script from "./AuthForgot.vue?vue&type=script&lang=js&"
export * from "./AuthForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d42261')) {
      api.createRecord('15d42261', component.options)
    } else {
      api.reload('15d42261', component.options)
    }
    module.hot.accept("./AuthForgot.vue?vue&type=template&id=15d42261&", function () {
      api.rerender('15d42261', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthForgot.vue"
export default component.exports